module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"check":"You have not given permission to access your camera or microphone.","p1":"To the left of the site address, click on the lock icon","p2":"Allow access to your camera and microphone;","p3":"Refresh the page","p3.check":"or click here"}}')
  delete Component.options._Ctor
}
